import { createFileRoute } from '@tanstack/react-router'
import { SettingsShowcasePage } from '@/pages/settingsShowcase'

export const Route = createFileRoute('/_app/settings/showcase')({
  component: SettingsShowcasePage,
})
